import styled from 'styled-components';
import { Container as UploadContainer } from 'components/Upload/styles';
import { Container as Select } from '../../components/Select/styles';

export const Container = styled.div`
  height: 100%;
  header {
    display: flex;
    align-items: center;
    //margin-left: 20%;
    justify-content: space-between;
    .mailicon {
      margin-left: 10px;
    }

    border-bottom: 1px solid ${props => props.theme.backgroundSecondary};
    ${Select} {
      // width: 300px;
      .react-select__control {
        flex-wrap: nowrap;
      }
      .react-select__value-container {
        flex-wrap: nowrap;
        width: 100%;
      }

      .react-select__indicators {
        display: -webkit-box !important;
      }
    }
    ${UploadContainer} {
      align-items: flex-end;
      width: auto;
      svg {
        margin-left: 0.4rem;
      }
      .dropzone {
        button {
          height: 36px;
          padding: 0.1rem 0.6rem;
        }
      }
    }
    span {
      min-width: 220px;
      color: ${props => props.theme.fontColor};
      font-style: italic;
      opacity: 0.8;
      text-align: right;
      white-space: nowrap;
    }

    section {
      align-items: flex-end;
      min-width: 410px;
    }

    .sendMailButton {
      margin-left: 260px;
    }
  }

  h6 {
    color: ${props => props.theme.fontColor};
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.1rem;
    max-width: 60%;
    margin-bottom: 0;
  }

  span {
    text-align: baseline;
    strong {
      color: ${props => props.theme.purple};
    }
  }
`;
